import { isProduction, isStaging } from 'helpers/envInfo'


let ROOT_PATH = ''

if (isStaging){
    ROOT_PATH = '/widget-staging'
}

if(isProduction) {
    ROOT_PATH = '/widget'
}

export const LIST = `${ROOT_PATH}/`
export const LOGIN = `${ROOT_PATH}/login`
export const EMAIL = `${ROOT_PATH}/email`
